import React from 'react';
import {RiseInterstitialProps} from 'screens/InsomniaSurvey/components/RiseInterstitialTemplate/RiseInterstitialBase';
import styles from './InsuranceCoveredInterstitial.module.css';
import RiseInterstitialTemplate from 'screens/InsomniaSurvey/components/RiseInterstitialTemplate/RiseInterstitialTemplate';

const Bullet = () => (
  <svg
    className={styles.bulletIcon}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0Z"
      fill="#E8DEFF"
    />
    <path
      d="M15.127 7.46875L9.10986 13.4858L4.97311 9.34909"
      stroke="#382365"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const InsuranceCoveredInterstitial: React.FC<RiseInterstitialProps> = () => {
  const bulletItems = [
    `<b>No more second-guessing:</b> Understand your insomnia risk and get a plan that fits you.`,
    '<b>Real guidance, not generic tips:</b> Direct access to sleep experts for tailored support.',
    '<b>Fits your life:</b> Reschedule anytime, up to 24 hours in advance.',
    '<b>Covered and clear:</b> No surprise bills—we handle insurance up front.',
  ];
  // Results screen
  return (
    <RiseInterstitialTemplate
      headerText={<div className={styles.headerText}>You're covered for a plan with licensed sleep experts</div>}
      bodyText={
        <>
          <div className={styles.dividerSection}>
            <div className={styles.dividerLine}></div>
            <div className={styles.dividerPill}>EXPERT CHAT SESSIONS</div>
            <div className={styles.dividerLine}></div>
          </div>
          <div className={styles.bulletsContainer}>
            {bulletItems.map((item, index) => (
              <div key={index} className={styles.bulletItem}>
                <Bullet />
                <span dangerouslySetInnerHTML={{__html: item}} />
              </div>
            ))}
          </div>
        </>
      }
      continueButtonTitle="Next"
    />
  );
};

export default InsuranceCoveredInterstitial;
